export default __webpack_public_path__ + "static/media/payment-screen3.54531170.jpg";